import { GET_ORDERS, AUTH_ERROR} from "../actions/types";

const initialState = {
    // token: localStorage.getItem("token"),
    orders: null,
    loading: true,
    
  };

  export default function orders(state = initialState, action) {
    const { type, payload } = action;
    // console.log(payload);
    switch (type) {
      case GET_ORDERS:
        return {
          ...state,
          orders: payload,
          loading: false,
         
        };
     
      //  case LOGIN_FAIL:
    
      case AUTH_ERROR:
      
        return { ...state,  isAuthenticated: false, loading: false,  };
    
  
      default:
        return state;
    }
  }